import type { ChatAttachment } from "../types";

export function getAttachmentDisplayName(
  attachment?: ChatAttachment,
  fallback?: null | string,
): string {
  return attachment?.displayName || attachment?.name || fallback || "";
}
